
import {
  defineComponent,
  ref,
  reactive,
  onMounted,
  computed,
} from 'vue'
import { useStore } from 'vuex'
import Swal from 'sweetalert2'
import axios from 'axios'
import { Modal,notification } from 'ant-design-vue'
import { useRouter } from 'vue-router'
import {  h } from 'vue';

export default defineComponent({
  components: {

  },

  setup () {
    const showUploadForm = ref(false)
    const router = useRouter()
    const form_action = ref('save')
    const store = useStore()

    const fields = ref([
        {
            title: 'Vendor',
            dataIndex: 'invoice_number',
        },
        {
            title: 'Invoice No.',
            dataIndex: 'invoice_number',
        },
        {
            title: 'Invoice Amount',
            dataIndex: 'invoice_amount',
        },
        {
            title: 'Invoice Description',
            dataIndex: 'invoice_description',
        },
        {
            title: 'Action',
            dataIndex: 'action',
            slots: {customRender: 'action'},
            align: 'center'
        }
    ])

    const index = (payload = {page: 1}) => {
        store.dispatch('EmployeeInvoice/index', payload)
    }

    const filterRecord = (payload: any) => {
        index(payload)
    }

    const createRecord = () => {
      router.push('/personnel/invoice/create/employee');
    }

    const editRecord = (record: any) => {
      router.push({path: '/personnel/invoice/edit/employee/'+record.id});
    }

    const deleteRecord = (record: any) => {
        store.dispatch('EmployeeInvoice/destroy', record.id)
    }


    onMounted(() => {
        index()
    })

    const items = computed(() => store.getters['EmployeeInvoice/items'])
    const loading = computed(() => store.getters['EmployeeInvoice/status'])

    return {
      items,
      loading,
      fields,
      form_action,
      showUploadForm,
      filterRecord,
      createRecord,
      editRecord,
      deleteRecord
    }
  },
})
